module.exports = __webpack_public_path__ + "static/media/digital_marketing.76498a1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/digital_marketing.svg
// module id = 383
// module chunks = 0